export default __webpack_public_path__ + "static/media/PromoMobile.13444cdb.png";